import { useEffect, useState } from 'react'

const PREFIX = 'liquorice-dashboard:'

/**
 * useState, только значение переживает перезагрузку страницы — раскрытые
 * панели, выбранный рынок, окно приёмки и т.п. живут в localStorage под
 * своим ключом. Испорченное или отсутствующее значение — тихо на дефолт,
 * а не падение экрана.
 */
export function usePersistedState<T>(
  key: string,
  initial: T,
): [T, (value: T | ((prev: T) => T)) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      return raw != null ? (JSON.parse(raw) as T) : initial
    } catch {
      return initial
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(state))
    } catch {
      // приватный режим / квота — переживаем без персистентности
    }
  }, [key, state])

  return [state, setState]
}
